import React, { useEffect, useState } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "./card.css";
import { Link } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import { FaHeart } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { setFavouriteMovies } from "../../utils/store/slice/movieSlice";

const Cards = ({ movie }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [iconColor, setIconColor] = useState("white");
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, []);

  const handleFavourite = (e, movie) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(setFavouriteMovies(movie));
    setIconColor("red");
  };

  return (
    <>
      {isLoading ? (
        <div className="cards">
          <SkeletonTheme color="#202020" highlightColor="#444">
            <Skeleton height={300} duration={2} />
          </SkeletonTheme>
        </div>
      ) : (
        <>
          <Link
            to={`/movie/${movie?.id}`}
            style={{ textDecoration: "none", color: "white" }}
          >
            {movie?.poster_path && (
              <div className="cards relative" key={movie.id}>
                <img
                  className="cards__img"
                  src={`https://image.tmdb.org/t/p/original${
                    movie ? movie.poster_path : ""
                  }`}
                  alt=""
                />
                <div className="cards__overlay">
                  {user?.email && (
                    <div
                      className="absolute top-1 right-4"
                      onClick={(e) => handleFavourite(e, movie)}
                    >
                      {iconColor === "white" ? (
                        <FiHeart size={24} color={iconColor} />
                      ) : (
                        <FaHeart size={24} color={iconColor} />
                      )}
                    </div>
                  )}
                  <div className="card__title">
                    {movie ? movie.original_title : ""}
                  </div>
                  <div className="card__runtime">
                    {movie ? movie.release_date : ""}
                    <span className="card__rating">
                      {movie ? movie.vote_average : ""}
                      <FaStar />
                    </span>
                  </div>
                  <div className="card__description">
                    {movie ? movie.overview.slice(0, 118) + "..." : ""}
                  </div>
                </div>
              </div>
            )}
          </Link>
        </>
      )}
    </>
  );
};

export default Cards;
